var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuplicateicon = function SvgDuplicateicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.8 11.2V1.6A1.6 1.6 0 0 0 11.2 0H1.6A1.6 1.6 0 0 0 0 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6ZM1.6 1.6h9.6v9.6H1.6V1.6Zm12.8 11.2V3.2A1.6 1.6 0 0 1 16 4.8v8a3.2 3.2 0 0 1-3.2 3.2h-8a1.6 1.6 0 0 1-1.6-1.6h9.6a1.6 1.6 0 0 0 1.6-1.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgDuplicateicon;